import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { push } from '../../services/router-utils';
import Menu from '../../components/menu';
import MenuTab from '../../components/menu-tab';
import withTranslate from '../../hoc/with-translate';
import { getUserBySlug } from '../../selectors/user-selectors';
import { getFollowersCount, getFollowingCount } from '../../services/counters';

const TABS = [
  {
    type: 'followers',
    className: 'followers-menu__followers-tab',
    title: 'followers-menu.followers',
    getPath: userSlug => `/profiles/${userSlug}/followers`,
  },
  {
    type: 'following',
    className: 'followers-menu__following-tab',
    title: 'followers-menu.following',
    getPath: userSlug => `/profiles/${userSlug}/following`,
  },
];

export class FollowersMenu extends Component {
  navigateTo = ({ getPath }) => event => {
    event.preventDefault();

    const { push, params: { userSlug } } = this.props;
    push(getPath(userSlug));
  };

  render = () => {
    const { t, counters, router, params: { userSlug } } = this.props;
    return (
      <Menu>
        {TABS.map((tab, key) =>
          <MenuTab
            key={key}
            className={tab.className}
            title={t(tab.title)}
            count={counters[tab.type]}
            onClick={this.navigateTo(tab)}
            isActive={router.isActive(tab.getPath(userSlug))}
          />
        )}
      </Menu>
    );
  };
}

FollowersMenu.propTypes = {
  router: PropTypes.object,
  t: PropTypes.func,
  push: PropTypes.func,
  params: PropTypes.object,
  counters: PropTypes.shape({
    followers: PropTypes.number,
    following: PropTypes.number,
  }),
};

const mapStateToProps = (state, props) => {
  const user = getUserBySlug(state, props.params.userSlug);
  return {
    counters: {
      followers: getFollowersCount(user),
      following: getFollowingCount(user),
    },
  };
};

const mapDispatchToProps = {
  push,
};

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withTranslate
)(FollowersMenu);



// WEBPACK FOOTER //
// ./app/containers/followers-menu/followers-menu.js